export const CURSOR_PREFIX = 'arrayconnection:';
export const PAGE_LIMIT = 50;
